"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTotalDealTypesQuery = exports.useGetTotalInfluencedArrByDealQuery = exports.TotalInfluencedByDealTag = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _utils = require("@alycecom/utils");

var _EmptyGatewayApi = require("../../EmptyGatewayApi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TotalInfluencedByDealTag;
exports.TotalInfluencedByDealTag = TotalInfluencedByDealTag;

(function (TotalInfluencedByDealTag) {
  TotalInfluencedByDealTag["InfluencedByDealType"] = "TotalInfluencedByDealTag_InfluencedByDealType";
})(TotalInfluencedByDealTag || (exports.TotalInfluencedByDealTag = TotalInfluencedByDealTag = {}));

var totalInfluencedArrByDeal = _EmptyGatewayApi.emptyGatewayApi.enhanceEndpoints({
  addTagTypes: [TotalInfluencedByDealTag.InfluencedByDealType]
}).injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getTotalInfluencedArrByDeal: build.query({
        query: function query(_ref) {
          var filters = (0, _extends2["default"])({}, _ref);
          return "/reporting/roi/salesforce/influenced-deal?".concat((0, _utils.queryParamsBuilder)(_objectSpread({}, filters)));
        }
      }),
      getTotalDealTypes: build.query({
        query: function query() {
          return '/reporting/roi/salesforce/deal-types';
        }
      })
    };
  }
});

var useGetTotalInfluencedArrByDealQuery = totalInfluencedArrByDeal.useGetTotalInfluencedArrByDealQuery,
    useGetTotalDealTypesQuery = totalInfluencedArrByDeal.useGetTotalDealTypesQuery;
exports.useGetTotalDealTypesQuery = useGetTotalDealTypesQuery;
exports.useGetTotalInfluencedArrByDealQuery = useGetTotalInfluencedArrByDealQuery;